import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import { CustomHttpMetaResponseModel, CustomHttpResponseModel } from '../models/response_model';
import { environment } from 'src/environments/environment';
import { AlertService } from '../utils/widgets/alert/alert.service';

const headers = new HttpHeaders({
  'Content-Type': 'application/json'
});

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(
    private http: HttpClient,
    private alert: AlertService
  ) {
  }


  public authvip(jsonData: any):Observable<any> {
    return this.http.post(`${environment.apiUrl}surveycustomer/authvip`, jsonData, { headers: headers });
  }

  public getquestion(): Observable<any> {
    return this.http.get(`${environment.apiUrl}surveycustomer/listquestion`, { headers: headers });
  }

  public sendotp(jsonData: any):Observable<any> {
    return this.http.post(`${environment.apiUrl}surveycustomer/sendotp`, jsonData, { headers: headers });
  }

  public verificationotp(jsonData: any):Observable<any> {
    return this.http.post(`${environment.apiUrl}surveycustomer/verification`, jsonData, { headers: headers });
  }

  public savesurveys(jsonData: any):Observable<any> {
    return this.http.post(`${environment.apiUrl}surveycustomer/savesurvey`, jsonData, { headers: headers });
  }

  public initgetvouchers(params: any): Observable<any> {
    return this.http.get(`${environment.apiUrl}surveycustomer/member_voucher/${params}`, { headers: headers })
  }




}
